var React = require('react');

function PlusThin (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_52321","data-name":"Group 52321","transform":"translate(-1740 -389)"},[React.createElement("rect",{"id":"Rectangle_49915","data-name":"Rectangle 49915","width":"22","height":"22","transform":"translate(1740 389)","fill":"none","key":0}),React.createElement("path",{"id":"plus-r","d":"M11.25,12.75v7h1.5v-7h7v-1.5h-7v-7h-1.5v7h-7v1.5Z","transform":"translate(1739 388)","key":1})]));
}

PlusThin.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = PlusThin;

PlusThin.default = PlusThin;
